import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  paper: {
    borderRadius: 12,
    boxShadow: '0px 4px 15px #6A6A6E',
    padding: '16px 0px',
    width: '27.55vw',
    minWidth: 600,
    overflow: 'hidden',
  },
  content: {
    height: 500,
    paddingLeft: 16,
  },
});
